import styled from 'styled-components';

export const MoneyInputWrapper = styled.div`
  input {
    text-align: right;
  }
`;

export const DiffList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
    font-size: 14px;

    &:last-child {
      border-bottom: none;
    }
  }
`;

export const DiffOld = styled.span`
  color: #9f3a38;
  text-decoration: line-through;
  margin-right: 8px;
`;

export const DiffNew = styled.span`
  color: #2c662d;
  font-weight: 600;
`;

export const DiffLabel = styled.strong`
  display: block;
  margin-bottom: 2px;
  color: #333;
`;

export const ReadOnlyGrid = styled.div`
  background: #f8f9fa;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 16px;
`;
